import React, { useEffect, useState } from 'react'

export default function Countdown({
  stakingTimeSecond,
  className,
}: {
  stakingTimeSecond: number
  className?: string
}) {
  const [remainingTime, setRemainingTime] = useState(
    stakingTimeSecond - Math.floor(Date.now() / 1000)
  )

  useEffect(() => {
    const interval = setInterval(() => {
      setRemainingTime((prevRemainingTime) => {
        if (prevRemainingTime <= 0) {
          clearInterval(interval)
          return 0
        }
        return prevRemainingTime - 1
      })
    }, 1000)

    return () => clearInterval(interval)
  }, [])

  if (remainingTime <= 0) {
    return <span className="status-fail">Finished</span>
  }

  const years = Math.floor(remainingTime / 31536000)
  const months = Math.floor((remainingTime % 31536000) / 2592000)
  const days = Math.floor((remainingTime % 2592000) / 86400)
  const hours = Math.floor((remainingTime % 86400) / 3600)
  const minutes = Math.floor((remainingTime % 3600) / 60)
  const seconds = remainingTime % 60

  const countdownParts = []
  if (years > 0) countdownParts.push(`${years}y`)
  if (months > 0) countdownParts.push(`${months}m`)
  if (days > 0) countdownParts.push(`${days}d`)
  countdownParts.push(`${hours}h`, `${minutes}m`, `${seconds}s`)

  return <span className={className}> {countdownParts.join(' ')}</span>
}
